"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeading = exports.Summary = exports.RowContent = exports.Row = exports.ProviderTitle = exports.ProviderTitleSpecialtiesContainer = exports.ProviderSpecialities = exports.ProviderImg = exports.ProviderImgContainer = exports.Link = exports.Container = exports.Content = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const image_component_1 = __importDefault(require("@kyruus/image-component"));
exports.Content = (0, styled_1.default)('div') `
  > div {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.Container = (0, styled_1.default)('div') `
  display: block; // needed for position: sticky above
`;
exports.Link = (0, styled_1.default)('a') `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
exports.ProviderImgContainer = styled_1.default.span `
  width: 25%;
`;
exports.ProviderImg = (0, styled_1.default)(image_component_1.default) `
  width: ${({ enhancementEnabled }) => (enhancementEnabled ? 'unset' : '100%')};
  max-height: ${({ enhancementEnabled }) => enhancementEnabled ? 'unset' : '100%'};
`;
exports.ProviderSpecialities = styled_1.default.div `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.ProviderTitleSpecialtiesContainer = styled_1.default.span `
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  flex: 0.75 0 0;
`;
exports.ProviderTitle = styled_1.default.span `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
`;
exports.Row = styled_1.default.div `
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.RowContent = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.Summary = styled_1.default.section `
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  > div {
    border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
  }
  > div:first-of-type {
    display: flex;
    border-top: none;
  }
`;
exports.SubHeading = (0, styled_1.default)(exports.RowContent) `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
//# sourceMappingURL=styles.js.map